import React, { useEffect, useState } from "react";
import DashboardMenus from "./DashboardMenus";
import './css/appsidebar.css'

const Appsidebar = () => {
  return (
    <>
    <div className="infivideo">
        <video autoPlay loop muted id="myVideo" playsInline>
          <source src="assets/images/INFIBGVIDEO.mp4" type="video/mp4"/>
          Your browser does not support HTML5 video.
        </video>
      </div>
      <div className="websidebar position-relative">
     
        <nav id="sidebar">
          <div className="sideinr pt-4">
            <div className="sidebar_logo d-none">
              <span>
                <img
                  src="assets/images/mainlogo.png"
                  className="mainlogo"
                  alt="mainlogo"
                />
              </span>
            </div>
            <DashboardMenus />
          </div>
        </nav>
      </div>
    </>
  );
};

export default Appsidebar;
